import React, { useEffect, useState } from "react";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "../alerts/AlertContext";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import {
    CONFIGURATION_CATEGORY_URL,
    CONFIGURATION_ENVIRONMENT_URL,
    CONFIGURATION_RELATIONSHIP_URL,
    MAINTENANCE_WINDOW_URL,
    AFFECTED_SERVICES_URL,
    CHANGE_TYPE_URL
} from "../../Constants/Constants";

const ConfigurationMasterForm = ({
    open,
    onClose,
    editData = null,
    onSaved,
    type
}) => {

    const showAlert = useAlert();

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        enabled: true
    });

    const [saving, setSaving] =
        useState(false);


    const config = {

        category: {
            title: "Configuration Category",
            url: CONFIGURATION_CATEGORY_URL
        },

        environment: {
            title: "Configuration Environment",
            url: CONFIGURATION_ENVIRONMENT_URL
        },

        relationship: {
            title: "Configuration Relationship",
            url: CONFIGURATION_RELATIONSHIP_URL
        },
        
        maintenancewindow:
        {
            title: "Maintenance Window",
            url: MAINTENANCE_WINDOW_URL
        },
        affectedservice:
        {
            title: "Affected Service",
            url: AFFECTED_SERVICES_URL
        },
        changetype:
        {
            title: "Change Type",
            url: CHANGE_TYPE_URL
        }

    }[type];


    useEffect(() => {

        if (editData) {

            setFormData({
                name: editData.name ?? "",
                description:
                    editData.description ?? "",
                enabled:
                    editData.enabled !== undefined &&
                        editData.enabled !== null
                        ? editData.enabled
                        : true
            });

        } else {

            setFormData({
                name: "",
                description: "",
                enabled: true
            });
        }

    }, [editData, open]);


    const handleChange = (event) => {

        const {
            name,
            value
        } = event.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleEnabledChange = (event) => {

        setFormData(prev => ({
            ...prev,
            enabled:
                event.target.value === "true"
        }));
    };


    const handleSubmit = async () => {

        if (!formData.name.trim()) {

            showAlert(
                "Name is required",
                "error"
            );

            return;
        }

        try {

            setSaving(true);

            const payload = {
                name: formData.name.trim(),
                description:
                    formData.description.trim(),
                enabled: formData.enabled
            };

            let response;

            if (editData?.id) {

                response =
                    await AxiosInstance.put(
                        `${config.url}/${editData.id}`,
                        payload
                    );

            } else {

                response =
                    await AxiosInstance.post(
                        config.url,
                        payload
                    );
            }

            showAlert(
                editData
                    ? `${config.title} updated successfully`
                    : `${config.title} created successfully`,
                "success"
            );

            onSaved?.(response.data);

            onClose();

        } catch (error) {

            console.error(error);

            showAlert(
                error?.response?.data?.message ||
                `Unable to save ${config.title}`,
                "error"
            );

        } finally {

            setSaving(false);
        }
    };


    return (
        <Dialog
            open={open}
            onClose={
                saving
                    ? undefined
                    : onClose
            }
            fullWidth
            maxWidth="sm"
        >

            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}
            >

                {editData
                    ? `Edit ${config.title}`
                    : `Add ${config.title}`}

                <IconButton
                    onClick={onClose}
                    disabled={saving}
                >
                    <CloseIcon />
                </IconButton>

            </DialogTitle>


            <DialogContent dividers>
                <ThemeProvider>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            pt: 1
                        }}
                    >

                        <TextField
                            fullWidth
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            autoFocus
                        />


                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Description"
                            name="description"
                            value={
                                formData.description
                            }
                            onChange={handleChange}
                        />


                        <FormControl>

                            <FormLabel>
                                Enabled
                            </FormLabel>

                            <RadioGroup
                                row
                                value={
                                    String(
                                        formData.enabled
                                    )
                                }
                                onChange={
                                    handleEnabledChange
                                }
                            >

                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Yes"
                                />

                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="No"
                                />

                            </RadioGroup>

                        </FormControl>

                    </Box>

                </ThemeProvider>
            </DialogContent>


            <DialogActions
                sx={{
                    px: 3,
                    py: 2
                }}
            >

                <Button
                    onClick={onClose}
                    disabled={saving}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={saving}
                >
                    {saving
                        ? "Saving..."
                        : editData
                            ? "Update"
                            : "Save"}
                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default ConfigurationMasterForm;